export default __webpack_public_path__ + "static/media/firebase.334c7505.svg";